import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { gql, useQuery } from '@apollo/client';

const GET_ZONES = gql`
  query { defenseZones { id name type geometryJson active } }
`;

export default function ZoneLayer() {
  const map = useMap();
  const { data } = useQuery(GET_ZONES, { pollInterval: 30000 });

  useEffect(() => {
    if (!data?.defenseZones) return;
    const layers: L.Layer[] = [];

    data.defenseZones.forEach((zone: any) => {
      if (!zone.active) return;
      const color = zone.type === 'DEFENSE' ? '#ef5350' : '#ffa726';
      try {
        const geo = typeof zone.geometryJson === 'string'
          ? JSON.parse(zone.geometryJson)
          : zone.geometryJson;

        const layer = L.geoJSON(geo, {
          style: {
            color,
            fillColor: color,
            fillOpacity: 0.15,
            weight: 2,
            dashArray: zone.type === 'WARNING' ? '6 4' : undefined,
          },
        });

        layer.addTo(map);
        layers.push(layer);
      } catch (e) {}
    });

    return () => { layers.forEach(l => map.removeLayer(l)); };
  }, [data, map]);

  return null;
}
